import { useState } from 'react'
import { customerData, CustomerInvoiceData } from '../../../utilities/CustomerData'
import { apiURL } from '../../../utilities/URLs'
import DashboardTOSModal from '../../Dashboard/DashboardScreens/DashboardTOS/DashboardTOS'
import { useNavigate } from 'react-router-dom'
import { GenerateInvoicePostPaid, GenerateInvoicePrePaid } from '../../Payment/PaymentModals'
import { refreshAccessToken } from '../../../utilities/extensions'

export function CollectionsWindow() {
  const navigate = useNavigate()

  const [showTOS, setShowTOS] = useState(false)
  const [customerStageTreeIndex, setCustomerStageTreeIndex] = useState(customerData.customerStageHistory.find(stage => stage.currentStage === true).customerStageTreeIndex)
  const [generatingInvoice, setGeneratingInvoice] = useState(false)
  const [showPostPaidInvoice, setShowPostPaidInvoice] = useState(false)
  const [showPrePaidInvoice, setShowPrePaidInvoice] = useState(false)
  const [tosCustomerFee, setTOSCustomerFee] = useState('15%')
  const [tosOptionClicked, setTOSOptionClicked] = useState(0)

  const handledSignedAndSetFee = async () => {
    await handleSignedTOS(tosCustomerFee, tosOptionClicked)
  }

  const handleShowInvoiceModal = () => {
    if (customerStageTreeIndex === 1)
      setShowPostPaidInvoice(true)
    else
      setShowPrePaidInvoice(true)
  }

  const handleSignedTOS = async (customerFee, optionClicked) => {
    setShowTOS(false)
    setGeneratingInvoice(true)

    const formData = new FormData()
    formData.append('customerInvoiceInfo', JSON.stringify({
      zohoId: customerData.customerLeadData.leadId,
      customerId: customerData.customerLeadData.leadContact.contactId,
      invoiceId: customerData.customerInvoiceData.invoiceId,
      customerName: customerData.customerLeadData.leadContact.contactName,
      customerEmail: customerData.customerLeadData.leadContact.contactEmail,
      customerRefundAmount: customerData.customerLeadData.leadAmount,
      customerFee: customerFee.toString(),
      currentInvoiceLink: customerData.customerInvoiceData.invoiceLinkURL
    }))

    const generateInvoiceResponse = await fetch(`${apiURL}/api/generateInvoice`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': customerData.accessToken
      }
    })
    const generateInvoiceData = await generateInvoiceResponse.json()
    setGeneratingInvoice(false)

    if (generateInvoiceData.response.error) {
      if (generateInvoiceData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleSignedTOS(customerFee) : navigate('/', { state: { expired: true } })
      } else
        console.error(generateInvoiceData.response.error)
    } else {
      customerData.customerInvoiceData = new CustomerInvoiceData(generateInvoiceData.response.invoiceData.invoiceInfo)

      if (optionClicked === 1)
        navigate('/addPaymentMethod')
      else
        navigate('/paymentPortal')
    }
  }

  return (
    <>
      <div className='lg:w-full w-11/12 flex flex-col gap-4'>
        <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-red-500 font-mont text-white'>
          <div className='w-full flex flex-col items-center'>
            <div className='w-full flex flex-col items-center gap-8'>
              <button 
                onClick={() =>  navigate('/paymentPortal', { state: { isCollections: true } })} 
                className='w-full p-4 bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200 rounded-full text-3xl font-bold shadow-md'>
                  <div className='flex flex-col items-center'>
                    <p className='text-2xl'>Pay Invoice</p>
                    <p className='text-lg'>Click Here</p>
                  </div>
              </button>
              <p className='font-bold text-lg'>The IRS has issued your SETC refund for at least one of the tax years we assisted you with. However, our recent attempt to process our fee was unsuccessful. To avoid potential collections and protect your credit, please take a moment to settle your invoice. Thank you for your prompt attention to this matter.</p>
            </div>
          </div>
        </div>
        <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
          <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
          <p className='font-bold text-xl text-[#646464]'>Please be advised that your invoice is past due and requires immediate attention. To avoid further collection actions, kindly remit payment as soon as possible. You can make your payment by click <span onClick={() =>  navigate('/paymentPortal', { state: { isCollections: true } })} className='text-[#FF8C00] underline cursor-pointer'>HERE</span></p>
        </div>
      </div>
      <GenerateInvoicePostPaid
        isOpen={showPostPaidInvoice}
        setIsOpen={setShowPostPaidInvoice}
        setShowTOS={setShowTOS}
        handleSignedTOS={handleSignedTOS}
        setTOSCustomerFee={setTOSCustomerFee}
        setTOSOptionClicked={setTOSOptionClicked}
        generatingInvoice={generatingInvoice}
      />
      <GenerateInvoicePrePaid
        isOpen={showPrePaidInvoice}
        setIsOpen={setShowPrePaidInvoice}
        setShowTOS={setShowTOS}
        handleSignedTOS={handleSignedTOS}
        setTOSCustomerFee={setTOSCustomerFee}
        generatingInvoice={generatingInvoice}
      />
      <DashboardTOSModal
        isOpen={showTOS}
        setIsOpen={setShowTOS}
        onClose={handledSignedAndSetFee}
      />
    </>
  )
}